import React from 'react';
import Account from './content/Account';
import PodPorsBlock from './content/podPor/PodPorsBlock';
import TCDuration from './content/TCDuration';
import VesselRequirements from './content/VesselRequirements';
import Cargo from './content/Cargo';
import CommissionAndContracts from './content/CommissionAndContracts';
import Terms from './content/Terms';
import Title from '../../../common/RequestTitle';

class TcOrderTable extends React.PureComponent {
    render() {
        const { numberOrderTable, tcOrder } = this.props;

        return (
            <div className='sidebar-table'>
                <Title 
                    orderNumber={this.props.numberOrderTable + 1}
                    text='TC REQUEST №'
                    warnings={tcOrder.warnings}
                />
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>Account</span>
                    <Account 
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>POD / POR</span>
                    <PodPorsBlock 
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>TC Duration</span>
                    <TCDuration
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>Vessel requirements</span>
                    <VesselRequirements 
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>Cargo</span>
                    <Cargo 
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>Commission and contract</span>
                    <CommissionAndContracts 
                        numberOrderTable={numberOrderTable} 
                        tcOrder={tcOrder} 
                    />
                </div>
                <div className='paper-block margin-bottom'>
                    <span className='name-block static huge-name'>Terms:</span>
                    <Terms 
                        numberOrderTable={this.props.numberOrderTable}
                        tcOrder={tcOrder} 
                    />
                </div>
            </div>
        );
    }
}

export default TcOrderTable;




// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/TcOrderTable.jsx